import NavBar from "./Components/NavBar";
import ItemPanel from "./Components/ItemPanel";
import "./CSS/panel.css";
import "./CSS/Colegiados.css";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useState, useEffect } from "react";
import ItemUsuario from "./Components/ItemUsuario";
import { useNavigate, Link } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import axios from "axios";

import {
  collection,
  getDocs,
  doc,
  deleteDoc,
  query,
  where,
  orderBy,
  addDoc,
} from "firebase/firestore";
import Box from "@mui/material/Box";

import TextField from "@mui/material/TextField";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { db } from "./FirebaseConfig/firebase";

const MySwal = withReactContent(Swal);

function Colegiados() {
  const navigate = useNavigate();
  const [codigosCip, setCodigosCip] = useState("");
  const [nombre, setNombre] = useState("");
  const [nombresList, setNombresList] = useState([]);
  const [listFilter, setListFilter] = useState([]);
  const [codigosList, setCodigosList] = useState([]);
  const colegiados = collection(db, `COLEGIADOS`);

  //funcion para buscar colegiados
  const buscarCodigos = async () => {
    const q = query(colegiados, orderBy("apellidos", "asc"));
    const data = await getDocs(q);
    setCodigosList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  const agregarColegiados = async (value) => {
    if (value == "") {
      Swal.fire({
        position: "center",
        title: "Ingrese código(s) CIP",
        icon: "error",
        showConfirmButton: false,
        timer: 1000,
      });
    } else {
      const arr = value.split(" ");
      const uniqueArray = arr.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
      Swal.fire({
        title: "AGREGANDO NUEVOS COLEGIADOS ",
        text: `Se van a agregar ${uniqueArray.length} nuevo(s) colegiado(s)`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, agregar!",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          uniqueArray.map(async (codigo) => {
            const res = await axios.get(
              `https://reservas.ciparequipa.org.pe/colegiados/${codigo}`
            );
            if (res != []) {
              console.log("el codigo es " + res.data[0].ndnicol);
              await addDoc(colegiados, {
                cip: res.data[0].ncodcol,
                dni: res.data[0].ndnicol,
                apellidos: res.data[0].vapecol,
                nombres: res.data[0].vnomcol,
              });
            }
          });
          let timerInterval;
          Swal.fire({
            title: "Cargando datos",
            html: "Quedan <b></b> segundos.",
            timer: uniqueArray.length * 100,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector("b");
              timerInterval = setInterval(() => {
                b.textContent = Swal.getTimerLeft() / 1000;
              }, 100);
            },
            willClose: () => {
              clearInterval(timerInterval);
            },
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              buscarCodigos();
              setCodigosCip("");
              console.log("I was closed by the timer");
            }
          });
        }
      });
      //buscarCodigos();
    }
  };

  const borrarTodo = async () => {
    Swal.fire({
      title: "BORRANDO TODOS LOS COLEGIADOS",
      text: `Se va a eliminar toda la lista de nuevos colegiados`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const q = query(colegiados);
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach(async (iddoc) => {
          console.log(iddoc.ref.id);
          const idDocumento = iddoc.ref.id.toString();
          await deleteDoc(doc(db, "COLEGIADOS", idDocumento));
          //doc.ref.delete();
        });
        let timerInterval;
        Swal.fire({
          title: "Eliminando datos",
          html: "Quedan <b></b> segundos.",
          timer: codigosList.length * 100,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
            const b = Swal.getHtmlContainer().querySelector("b");
            timerInterval = setInterval(() => {
              b.textContent = Swal.getTimerLeft() / 1000;
            }, 100);
          },
          willClose: () => {
            clearInterval(timerInterval);
          },
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            setCodigosList([]);
            buscarCodigos();
            setCodigosCip("");
            console.log("I was closed by the timer");
          }
        });
      }
    });
  };

  //uso de useEffect
  useEffect(() => {
    //getUsuarios();
  }, []);

  const cerrar = () => {
    if (localStorage.getItem("nombreLocal") == "CIP") {
      navigate("../panelCDA");
    } else {
      navigate("../panelAdmin");
    }
  };

  useEffect(() => {
    buscarCodigos();
  }, []);
  return (
    <div className="panel">
      <NavBar
        titulo="Nuevos Colegiados"
        imagen="cerrar"
        logoTitulo="colegiados"
        cerrar={cerrar}
      ></NavBar>
      <div className="colegiados-usuarios-buscador">
        <div className="colegiados-grid-container">
          <div style={{display:"flex",alignItems:"center"}}>
            <Box sx={{ width: 250 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PersonSearchIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Ingrese codigo(s) CIP"
                  variant="standard"
                  value={codigosCip}
                  onChange={(e) => setCodigosCip(e.target.value)}
                />
              </Box>
            </Box>
            <div className="fau-addUser">
              <input
                type="submit"
                value="  AGREGAR  "
                className="btn-agregar"
                onClick={() => {
                  agregarColegiados(codigosCip);
                }}
              />
            </div>
          </div>
          <div>
            <div className="col-deleteAll">
              <input
                type="submit"
                value="BORRAR TODO"
                className="btn-borrartodo"
                onClick={() => {
                  borrarTodo();
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="reporte-cabecera">
        <h1 className="cd">Nuevos colegiados : {codigosList.length}</h1>
      </div>
      <div className="reporte-tabla">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <b>CODIGO CIP</b>
                </TableCell>
                <TableCell align="center">
                  <b>APELLIDOS</b>
                </TableCell>
                <TableCell align="center">
                  <b>NOMBRES</b>
                </TableCell>
                <TableCell align="center">
                  <b>DNI</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {codigosList.map((row) => (
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{row.cip}</TableCell>
                  <TableCell align="center">{row.apellidos}</TableCell>
                  <TableCell align="center">{row.nombres}</TableCell>
                  <TableCell align="center">{row.dni}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default Colegiados;
